module.exports = __webpack_public_path__ + "static/media/Orders.a1e5e180.svg";